import { Build } from "~/components/build/Show/lib/types";
import { queryOptions, UseQueryOptions } from "@tanstack/react-query";
import fetcher from "~/components/build/Show/lib/fetcher";

export const buildQueryKey = (buildId: Build["id"]) => {
  return ["build", buildId];
};

export const buildQueryOptions = (
  buildId: Build["id"],
  buildJsonPath: Build["jsonPath"],
  queryOptionsArgs: Omit<UseQueryOptions<Build>, "queryKey" | "queryFn"> = {},
) => {
  return queryOptions({
    queryKey: buildQueryKey(buildId),
    queryFn: ({ signal }) => fetchBuild(buildJsonPath, signal),
    ...queryOptionsArgs,
  });
};

function fetchBuild(jsonPath: Build["jsonPath"], signal: AbortSignal): Promise<Build> {
  const url = new URL(jsonPath, window.location.origin);

  return fetcher<Build>(url, true, { signal });
}
